<template>
  <div class="bgView">
    <mu-paper class="insetGraph">
      <mu-tabs v-model="selectedTab">
        <mu-tab value="bloodGlucose">
          {{$t('message.cardBloodGlucose')}}
        </mu-tab>

        <mu-tab value="hba1c" @click.native="goTo('HbA1cProgress')">
         {{$t('message.cardHbA1c')}}
        </mu-tab>
      </mu-tabs>

      <bg-line-graph
        v-if="$store.state.user.scope"
        :userId="$store.state.user.scope.user_id"
      ></bg-line-graph>
    </mu-paper>
    <mu-row gutter v-if="$store.state.user.scope" class="content">
      <mu-col desktop="30" tablet="50" width="100">



       <blood-glucose-range

         style="margin-top: 24px;"
       ></blood-glucose-range>


        <blood-glucose-input
          style="margin-top: 24px;"
          class="card-spacing bottom"
          v-if="$store.state.user.settings"
          :hba1c="$store.state.user.settings.hba1c"
          :bloodGlucose="$store.state.user.settings.blood_glucose"
        ></blood-glucose-input>


        <hba1c-input
          v-if="$store.state.user.settings"
          :hba1c="$store.state.user.settings.hba1c"
          class="bottom">
        </hba1c-input>

        <blood-glucose-targets
          :hba1c="$store.state.user.settings.hba1c"
          :bloodGlucose="$store.state.user.settings.blood_glucose"
        ></blood-glucose-targets>


        <tracking-exporter
          type="blood-glucose"
        ></tracking-exporter>

        <tracking-notifier
          :userId="$store.state.user.scope.user_id"
        ></tracking-notifier>
      </mu-col>
      <mu-col desktop="70" tablet="50">
        <mu-card
          style="margin-top: 24px;"
          id="blood-glucose-data"
          class="tracking-data"
        >
          <mu-card-text>
            <p class="tracking-subtext" v-text="$t('message.trackingHelpText')"></p>
          </mu-card-text>
          <mu-timeline v-if="readingTags.length > 0">
            <div v-for="group, groupKey in groupFilter()" :key="'group-key-' + groupKey" style="margin-bottom: 16px;">
              <div v-for="titleItem, titleIndex in group" v-if="titleIndex === 0" class="timelineSpacing">
                <div class="bold timelineTitle"
                     v-text="groupedDateFormat(titleItem.date_created)">
                </div>
              </div>
              <div v-for="item, index in group" class="timelineSpacing" :key="'tracking-timeline-item-' + index" v-bind:class="{notEditMode: !item.isEditMode}">
                <mu-timeline-item
                  :iconColor="determineColor(item)"
                  iconLine="8"
                  iconType="solid"
                  @click.native="showItemControls(item)"
                >
                  <mu-row>
                    <mu-col>
                      <div class="trackingDate" v-if="!item.isEditMode"
                           v-text="groupedItemDate(item.date_created)"></div>
                    </mu-col>
                    <mu-col>
                      <div v-if="!item.isEditMode" v-bind:class="{spacingBottom: item.isControlsVisible}"
                           class="reading"
                          >
                        <span v-if="item.userDevice && item.userDevice.userDeviceId !== 0">
                         <img style="position:relative;top: 6px;"  v-tooltip.left="$t('message.cardFromDevice') +   item.userDevice.nickname"  width="22" :src="item.userDevice.device.iconBlue"/>
                        </span>
                        <span v-text="data.preference === 'mmoll' ? '' +item.blood_glucose_mmoll + ' mmol/L' :  item.blood_glucose_mgdl + ' mg/dL'"></span>
                      </div>
                    </mu-col>
                  </mu-row>
                  <div v-if="item.tags.length > 0 && !item.isEditMode"
                       v-bind:class="{spacingBottom: item.isControlsVisible}">
                      <span v-for="(tag, tagIndex) in item.tags" :key="tagIndex" v-if="tag.tag_id !== null">
                            <span v-if="tagIndex === 0 && item.tags.length === 1">
                         <span v-if="tagIndex <= 1" v-text="$t(localizeTag(tag.tag))"></span>
                      </span>
                      <span v-if="item.tags.length > 1">
                        <span v-if="tagIndex <= 1"
                              v-text="$t(localizeTag(tag.tag)) + (tagIndex === 1 && !item.showAllTags ? '' : ', ') "></span>
                        <span v-if="tagIndex > 1 && item.showAllTags"
                              v-text="$t(localizeTag(tag.tag)) + (tagIndex === item.tags.length - 1 ? '' : ', ')"></span>
                        <a v-show="!item.showAllTags" v-if="tagIndex  == item.tags.length - 1 && item.tags.length > 2"
                           @click="showAllTags(item)">
                           <span>+</span><span v-text="item.tags.length - 2 + ' ' + String($t('message.moreText')).toLowerCase()"></span>
                        </a>
                          <a v-show="item.showAllTags" v-if="tagIndex  == item.tags.length - 1 && item.tags.length > 2"
                             @click="showAllTags(item)">
                           <span v-text="String($t('message.hideText')).toLowerCase()"></span>
                        </a>
                      </span>
                    </span>
                  </div>
                  <div class="no_tags" v-if="!item.isEditMode &&  item.tags.length === 0">
                   {{$t('message.labelNoTags')}}
                  </div>
                  <div v-if="item.isControlsVisible && !item.isEditMode" align="right">
                    <mu-flat-button
                      :color="btnColor"
                      :label="$t('message.editText')"
                      icon="edit"
                      @click.native="editReading(item)"
                    >
                    </mu-flat-button>
                    <mu-flat-button
                      :color="btnColor"
                      :label="$t('message.deleteText')"
                      icon="delete"
                      @click.native="deleteReading(item)"
                    ></mu-flat-button>
                  </div>
                  <div v-if="item.isEditMode">
                    <bg-edit
                      :tags="readingTags"
                      @updateReading="updateReading"
                      @closeEditPanel="closeEditMode(item)"
                      :preference="data.preference"
                      :item="item"
                    ></bg-edit>
                  </div>
                </mu-timeline-item>
              </div>
            </div>
          </mu-timeline>
          <mu-card-text align=" center" v-if="isReadingsLoading">
            <mu-circular-progress color="#0179d5"></mu-circular-progress>
            <div>{{$t('message.loadingText')}}</div>
          </mu-card-text>
          <div v-if="!isReadingsLoading" ref="detector"></div>
        </mu-card>
      </mu-col>
    </mu-row>
  </div>
</template>
<script>

  import BloodGlucoseApi from '../../api/Tracking/BloodGlucose'
  import ListsApi from '../../api/Lists'
  import SettingsApi from '../../api/Settings'
  import BgLineGraph from "../../components/Tracking/Graphs/BloodGlucose/LineGraph";
  import BloodGlucoseInput from "../../components/Tracking/Input/BloodGlucose/BloodGlucose";
  import BgEdit from "../../components/Tracking/Edit/BloodGlucose/BloodGlucoseEdit.vue";
  import TrackingDetailMixin from '../../mixins/TrackingDetailMixin'
  import TrackingNotifier from "../../components/TrackingNotifier/TrackingNotifier.vue";
  import TrackingExporter from "../../components/Tracking/Exporter/Exporter.vue";
  import Hba1cInput from "../../components/Tracking/Input/HbA1c/HbA1c";


  import BloodGlucoseTargets from "../../components/Tracking/Targets/BloodGlucose";
  import BloodGlucoseRange from "../../components/Tracking/Visualizations/BloodGlucose/BloodGlucoseRange";
  import TagLocalizerMixin from '../../mixins/Localization/BgTags/TagLocalizerMixin'

  let fromDate = moment().subtract(1, 'month');
  let toDate = moment();

  export default {
    components: {
      BloodGlucoseRange,
      BloodGlucoseTargets,
      Hba1cInput,
      TrackingExporter,
      TrackingNotifier,
      BgEdit,
      BloodGlucoseInput,
      BgLineGraph
    },
    mixins: [TrackingDetailMixin, TagLocalizerMixin],
    data() {
      let self = this;
      return {
        btnColor: '#E84341',
        bgSettings: {},
        readingTags: [],
        selectedTab: "bloodGlucose"
      }
    },
    mounted() {
      let self = this;

      self.$gtag.pageview('/tracking/blood-glucose');


      self.loadTags();
      SettingsApi.getBloodSugarSettings().then(function (response) {
        self.bgSettings = response.data;
        BloodGlucoseApi.getBloodGlucoseTrackingDetail(1, 15)
          .then(function (response) {
            self.data = response.data;
            self.isReadingsLoading = false;
            self.$forceUpdate();
          })
      });

      self.$EventBus.$on('bgPusherReceived', function () {
        self.isReadingsLoading = true;
        BloodGlucoseApi.getBloodGlucoseTrackingDetail(1, 15)
          .then(function (response) {
            self.data = response.data;
            self.isReadingsLoading = false;
            self.$forceUpdate();
          })
      });

    },
    methods: {
      goTo(name){
        let self = this;
        self.$router.push({
          name: name
        })
      },
      loadTags() {
        let self = this;
        let getData = ListsApi.getTagList();
        getData.then(function (response) {
          let data = response.data;
          data = data.sort(function (a, b) {
            let textA = a.tag.toUpperCase();
            let textB = b.tag.toUpperCase();
            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
          });
          self.readingTags = data;
          self.$forceUpdate();
        });
      },
      updateReading(data) {
        let self = this;
        let currentReading = self.data.data.filter(function (reading) {
          return reading.progress_id === data.progress_id
        })[0];

        currentReading.blood_glucose_mgdl = data.blood_glucose_mgdl;
        currentReading.blood_glucose_mmoll = data.blood_glucose_mmoll;
        currentReading.tags = data.tags;
        currentReading.date_created = data.date_created;

        self.$emit('updateGraphData');

        self.sortItems();
      },
      deleteReading(reading) {
        let self = this;
        let swal = self.$alert;
        self.$alert({
          title: self.$t('message.confirmRemoveTitle'),
          text: self.$t('message.confirmRemoveBloodGlucoseItem'),
          type: "warning",
          showCancelButton: true,
          showLoaderOnConfirm: false,
          confirmButtonColor: "white",
          cancelButtonColor: "white",
          preConfirm: function () {
            return BloodGlucoseApi.deleteGlucoseReading(reading.progress_id, reading.tracking_id)
          }
        })
          .then(function (response) {
            let index = self.data.data.indexOf(reading);
            self.data.data.splice(index, 1);
            self.$alert({
              title: self.$t('message.labelSuccess'),
              text: self.$t('message.confirmedRemoveBloodGlucoseItem'),
              type: "success",
              showCancelButton: false,
              confirmButtonColor: "white"
            })
          }.bind(self))
          .catch(self.$alert.noop)
      },
      determineRange(reading, preference) {
        let self = this;
        if (preference === 'mmoll') {
          if (reading.blood_glucose_mmoll > self.bgSettings.glucose_range.max) {
            return 'inHyper'
          }
          if (reading.blood_glucose_mmoll < self.bgSettings.glucose_range.min) {
            return 'inHypo'
          }
          if ((reading.blood_glucose_mmoll >= self.bgSettings.glucose_range.min) && (reading.blood_glucose_mmoll <= self.bgSettings.glucose_range.max)) {
            return 'inRange'
          }
        }
        if (preference === 'mgdl') {
          if (reading.blood_glucose_mgdl > self.bgSettings.glucose_range.max) {
            return 'inHyper'
          }
          if (reading.blood_glucose_mgdl < self.bgSettings.glucose_range.min) {
            return 'inHypo'
          }
          if ((reading.blood_glucose_mgdl >= self.bgSettings.glucose_range.min) && (reading.blood_glucose_mgdl <= self.bgSettings.glucose_range.max)) {
            return 'inRange'
          }
        }
      },
      determineColor(reading) {
        let self = this;
        /**
         *
         *@hyper: #E74C3C;
         @inRange: #8DC948;
         @hypo: #0179d5;
         *
         */
        if (self.determineRange(reading, self.data.preference) === 'inRange') {
          return "#8DC948";
        }
        if (self.determineRange(reading, self.data.preference) === 'inHypo') {
          return "#0179d5";
        }
        if (self.determineRange(reading, self.data.preference) === 'inHyper') {
          return "#E74C3C";
        }
      },
      showAllTags(item) {
        let self = this;
        if (item.showAllTags === undefined) {
          item.showAllTags = true;
        }
        else {
          item.showAllTags = !item.showAllTags;
        }
        self.$forceUpdate();
      },
      loadMoreData() {
        let self = this, page = self.data.page, pages = self.data.pages;
        if (page >= pages) {
          self.isReadingsLoading = false;
          return;
        }
        if ((page < pages)) {
          self.isReadingsLoading = true;
          page++;
          BloodGlucoseApi.getBloodGlucoseTrackingDetail(page, 15)
            .then(function (response) {
              self.data.page = response.data.page;
              self.data.data.push.apply(self.data.data, response.data.data);
              self.isReadingsLoading = false;
            })
        }
      }
    },
    beforeDestroy() {
      this.$EventBus.$off('bgReadingAdded');
      this.$EventBus.$off('bgPusherReceived');
    }
  }
</script>
<style lang="less">
  @import "./styles/trackingDetail.css";
  @bgBranding: #E84341;
  .bgView {
    .timelineSpacing {
      padding-top: 8px;
      padding-left: 16px;
      padding-right: 16px;
      padding-bottom: 0px;
    }
    .timelineSpacing.notEditMode:hover {
      background: fade(@bgBranding, 10%);
      cursor: pointer;
    }
    .no_tags {
      opacity: 0.7;
      font-size: 16px;
      line-height: 1.5;
      color: #9b9b9b;
    }
    @hyper: #E74C3C;
    @inRange: #8DC948;
    @hypo: #0179d5;
    .inRange {
      color: @inRange;
    }
    .hypo {
      color: @hypo;
    }
    .hyper {
      color: @hyper;
    }
    .bold {
      font-weight: bold;
    }
    #blood-glucose-data .tagGroup .tag {
      padding-left: 8px;
      color: initial !important;
      font-weight: normal;
    }
    #blood-glucose-data .tagGroup .tag img {
      padding-right: 8px;
      font-weight: normal;
    }
    .whiteTitle {
      font-size: 18px !important;
      color: white !important;
    }
    .reading {
      font-size: 16px;
    }
    /* Enter and leave animations can use different */
    /* durations and timing functions.              */
    .slide-fade-enter-active {
      transition: all .3s ease;
    }
    .slide-fade-leave-active {
      transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }
    .slide-fade-enter, .slide-fade-leave-to
      /* .slide-fade-leave-active below version 2.1.8 */
    {
      transform: translateX(10px);
      opacity: 0;
    }
  }

</style>



// WEBPACK FOOTER //
// BloodGlucose.vue?623c666d